import { LocalNotifications } from "@capacitor/local-notifications";

export const clearLocalNotifications = async (): Promise<void> => {
  try {
    const notifyCancel = await LocalNotifications.getPending();
    const notifications = Array.isArray(notifyCancel.notifications)
      ? notifyCancel.notifications
      : [];
    const ids = notifications.map((n: any) => ({ id: n.id }));
    if (notifications.length > 0) {
      await LocalNotifications.cancel({ notifications: ids });
    }
  } catch (err) {
    console.error("Error cancelling notifications on logout:", err);
  }
};
